import Helper from './Helper';

class Table {
  constructor() {
    this.tableSelector = '.ns-table-wrap table';
    this.tableSpanSelector = '.ns-table-wrap table td span';
    this.tableThSelector = '.ns-borderleft-ally';
    this.tableHeadSelector = 'td.head';
    this.footnoteSelector = '.ns-table-wrap .ns-style-footnote';

    this.tables = document.querySelectorAll(this.tableSelector);
    this.tableSpans = document.querySelectorAll(this.tableSpanSelector);
    this.tableThs = document.querySelectorAll(this.tableThSelector);
    this.tableHeads = document.querySelectorAll(this.tableHeadSelector);
    this.footnotes = document.querySelectorAll(this.footnoteSelector);

    if(this.tableSpans){
      this.bindContentCorrection();
      this.bindSrlNumberCorrection();
    }

    if(this.tableThs){
      this.bindThCorrection();
    }

    if(this.tableHeads){
      this.bindHeadsCorrection();
    }

    if(this.footnotes){
      this.bindItalicCorrection();
    }
  }

  bindContentCorrection(){
    this.tableSpans.forEach(span => {
      if(span.nextElementSibling?.classList.contains('sup') || span.nextElementSibling?.classList.contains('sub')) {
        span.insertAdjacentElement('beforeend', span.nextElementSibling);
      }

      if(
        span.innerHTML.trim().indexOf("–") == 0 &&
        isNaN(parseInt(span.innerHTML.trim().charAt(1))) &&
        isNaN(parseInt(span.innerHTML.trim().charAt(2)))
      ){
        let c1 = "<span>–</span>";
        let c2 = "<span>" + span.innerHTML.trim().substring(1) + "</span>";
        span.innerHTML = c1 + c2;
        span.classList.add('span__flex');
      }
      else if(
        span.innerHTML.trim().indexOf("+") == 0 &&
        isNaN(parseInt(span.innerHTML.trim().charAt(1))) &&
        isNaN(parseInt(span.innerHTML.trim().charAt(2)))
      ){
        let c1 = "<span>+</span>";
        let c2 = "<span>" + span.innerHTML.trim().substring(1) + "</span>";
        span.innerHTML = c1 + c2;
        span.classList.add('span__flex');
      }
    });
  }

  bindSrlNumberCorrection() {
    this.tableSpans.forEach(span => {
      if (span.classList.contains('srl-number') && span.innerHTML.trim() === '-') {
        span.innerHTML = ' ';
      }
    });
  }

  bindThCorrection(){
    if(window.screen.width >= 992){
      this.tableThs.forEach(cell => {
        let th = document.createElement('th');
        th.classList = cell.classList;
        th.innerHTML = cell.innerHTML;
        th.colSpan = cell.colSpan;
        th.rowSpan = cell.rowSpan;
        th.scope = cell.rowSpan >= 2 ? "rowgroup" : "row";
        cell.insertAdjacentElement('beforebegin', th);
        cell.remove();
      });
    }
  }

  bindHeadsCorrection(){
    if(window.screen.width >= 992){
      this.tableHeads.forEach(cell => {
        //console.log("cell.querySelector('span').innerHTML", cell.querySelector('span').innerHTML);
        if(cell.querySelector('span').innerHTML != '' && cell.querySelector('span').innerHTML != '&nbsp;'){
          let th = document.createElement('th');
          th.classList = cell.classList;
          th.innerHTML = cell.innerHTML;
          th.colSpan = cell.colSpan;
          th.rowSpan = cell.rowSpan;
          th.scope = cell.colSpan >= 2 ? "colgroup" : "col";
          cell.insertAdjacentElement('beforebegin', th);
          cell.remove();
        }
      });
    }
  }

  bindItalicCorrection() {
    this.footnotes.forEach(footnote => {
      const spans = footnote.querySelectorAll('span');
      spans.forEach(span => {
        const content = span.innerHTML;
        if (content.includes('&lt;italic&gt;')) {
          const correctedContent = content.replace(
            /(&lt;italic&gt;)(.*?)(&lt;italic&gt;)/g,
            '<i>$2</i>'
          );
          span.innerHTML = correctedContent;
        }
      });
    });
  }
}

export default Table;
